import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import ProductTypeCol from './ProductTypeCol'
import {Tag} from 'antd'
import moment from "moment"

class BatchRow extends Component {
    _generateLevel = (level) => {
        const color = level === 3 ? 'rgb(255 45 0)' : level === 2 ? '#FFD300' : ''
        switch (level) {
            case 3 :
                return <Tag className={classNames(`tag-highest`)} color={color}>highest</Tag>
            case 2 :
                return <Tag className={classNames(`tag-high`)} color={color}>high</Tag>
            default:
                return <Tag className={classNames(`tag-medium`)} color={color}>medium</Tag>
        }
    }

    render() {
        const {item, onChangeProductType, adminRole} = this.props
        const {created_at, product_types, packaged, partner, sewing_partner} = item
        const {user, date: packagedDate, items} = Object.assign({}, packaged)
        const {name: printingPartner} = {...partner}
        const {name: sewingPartner} = {...sewing_partner}

        return (
            <tr key={item._id}>
                <td className="Name">
                    <Link to={`/batches/${item._id}`} className="d-block">
                        {item.name}
                    </Link>
                    {
                        this._generateLevel(item.level_number)
                    }
                </td>
                <td className="CreatedAt">
                    {created_at ? moment(created_at).format("HH:mm DD/MM/YYYY") : ""}
                </td>
                <ProductTypeCol types={product_types} onChangeProductType={onChangeProductType}/>
                {adminRole &&
                    <td className="ItemCount">{items}</td>
                }
                <td className="User">{user}</td>
                <td className="PrintingPartner">{printingPartner || '-'}</td>
                <td className="SewingPartner">{sewingPartner || '-'}</td>
                <td className="PackagedAt">{packagedDate ? moment(packagedDate).format("HH:mm DD/MM/YYYY") : '-'}</td>
            </tr>
        )
    }
}

BatchRow.propTypes = {
    item: PropTypes.object.isRequired,
    onChangeProductType: PropTypes.func,
}

export default BatchRow
